import React, { ReactNode } from 'react';

import Menu, { MenuProps } from '../../../../../../Menu/Menu';
import { Item } from './components/Item/Item';

export interface SidebarMenuProps extends Omit<MenuProps, 'variant'> {
  children: ReactNode;
}

export const SidebarMenu = ({ children, 'aria-label': ariaLabel }: SidebarMenuProps) => (
  <Menu aria-label={ariaLabel}>{children}</Menu>
);

SidebarMenu.Item = Item;
